module.exports = __webpack_public_path__ + "img/shows/dragndrop.204339.png";